import React from "react";
import WidgetWrapper from "components/WidgetWrapper";
import FlexBetween from "components/FlexBetween";
import {
  Box,
  // Button,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@mui/material";
// import AddBusinessOutlinedIcon from "@mui/icons-material/AddBusinessOutlined";
import { useOrgAdmin } from "./hooks/useOrgAdmin";
import OrgForm from "./Components/OrgForm";
import OrgGrid from "./Components/orgGrid";
import Header from "components/Header";

function OrgAdmin() {
  const {
    open,
    editMode,
    currentOrg,
    // handleOpen,
    handleEditOpen,
    handleClose,
    setOpen,
    isLargeScreen,
  } = useOrgAdmin();

  return (
    <Box m={isLargeScreen ? "1rem" : "1.5rem 0.5rem 2rem 0.5rem"}>
      <WidgetWrapper>
        <FlexBetween>
          <Header
            title="ALT Coach Organisation Admin"
            subtitle="Administer your organisation details"
          />
        </FlexBetween>
        <OrgGrid handleEditOpen={handleEditOpen} />

        {/* The Dialog component is a modal dialog that is displayed over the current page. */}

        <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
          <DialogTitle>
            {editMode
              ? `Edit Organisation - ${currentOrg.name}`
              : "Add a New Organisation"}
          </DialogTitle>
          <DialogContent>
            <OrgForm
              editMode={editMode}
              currentOrg={currentOrg}
              setOpen={setOpen}
              handleClose={handleClose}
            />
          </DialogContent>
        </Dialog>
      </WidgetWrapper>
    </Box>
  );
}

export default OrgAdmin;
